import React, { Component } from "react";

//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import CampoNroTelefono from "./CampoNroTelefono"
import Select from "react-select";
import ConfigService from "../../../services/configuracion/ConfigService";
import history from "../login/history";
import $ from "jquery";
import { phoneNumberValido, phoneFormatter, formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import { trackPromise } from 'react-promise-tracker';
import SolicitudesService from "../../../services/solicitudes/SolicitudesService";
import Popup from "react-popup";
import { mensajeExito } from "../../generico/MensajeSistemaToast";
import ConfirmarOperacion from "../../pages/Alerta/ConfirmarOperacion";
import SeleccionTarjeta from "../../pages/Alerta/SeleccionTarjeta";
import { useLocation } from "react-router-dom";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faSave, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

export default class AgregarAlerta extends Component {
  constructor(props) {

    super(props);
    this.refTC = React.createRef();
    // this.state = this.props.location.state;
    this.state = {
      listaCombo: JSON.parse(sessionStorage.getItem("ListaAlertasCombo")),
      alerta: undefined,
      alertaSelected: undefined,
      costo: undefined,
      moneda: undefined,
      showMe: JSON.parse(sessionStorage.getItem("mostrarNumero")),
      lista: [],
      listaAlertasTarjetas: [],
      listaTC: [],
      mostrarTarjeta: true,
      telefonoActual: sessionStorage.getItem("NumeroActual")

    }
    this.obtenerListadoAlertasTarjetas = this.obtenerListadoAlertasTarjetas.bind(this);
  }

  funcionMostrarTarjeta = (childData) => {
    this.setState({ mostrarTarjeta: childData })
  }



  componentDidMount() {
    this.setState({ alertasDisp: this.getAlertasDisponibles() });
    // this.setState({ listaAlertasTarjetas: this.obtenerListadoAlertasTarjetas() });

  }
  phoneSelectorValue = (dataFromChild) => {

    var valor = this.formatearPhone(dataFromChild)
    var res = valor.split("_")

    if (res.length === 1)
      this.setState({
        phoneFormat: dataFromChild,
        telefono: valor,
        habAlert: true,
        showButtonChange: false
      });
    else
      this.setState({
        phoneFormat: dataFromChild,
        telefono: valor,
        habAlert: false
      });
  };

  formatearPhone = (valor) => {
    valor = valor.replace("(", "");
    valor = valor.replace(")", "");
    valor = valor.replace("-", "");

    return valor;

  }
  volverListadoAlertas = (e) => {

    history.push(ConfigService.getPathByName("suscripcionAlerta")?.url);
    window.location.reload();
  }
  loadDataConfirmAccion = () => {

    this.loadDataConfirm()

  }


  loadDataConfirm() {

    $.validator.setDefaults({
      submitHandler: () => {
        this.loadData();
      }
    });
    $("#idAlertaForm").submit(function (e) {

      e.preventDefault();
      $.validator.addMethod(
        "prefijos",
        function (value, element) {

          return phoneNumberValido(element.value);

        }
      );
      $.validator.addMethod(
        "prefijoMin",
        function (value, element) {
          var tam = phoneFormatter(element.value)
          if (tam.length < 10)
            return false
          return true;

        }
      );
      var data = {};
      var dataArray = $('#idAlertaForm').serializeArray();

      for (var i = 0; i < dataArray.length; i++) {

        data[dataArray[i].name] = dataArray[i].value;
        if (dataArray[i].name == "tipo" && dataArray[i].value === "") {

          e.target[0].classList.add("error")
          e.target[0].classList.add("is-invalid")

          e.target[0].name = "alerta"
          e.target[0].classList.add("is-invalid")
          var prueba = document.getElementById('prueba')
          prueba.classList.add("prueba")

        }
        if (dataArray[i].name == "tipo" && dataArray[i].value !== "") {
          e.target[0].name = ""
          var prueba = document.getElementById('prueba')
          prueba.classList.remove("prueba")
        }

      }

    }).validate(
      {
        ignore: "input[type='text']:hidden",
        rules: {
          alerta: {
            required: true,

          },
          tipo: {
            required: true,

          },
          telefono: {
            required: true,
            prefijos: { prefijos: false },
            prefijoMin: { prefijoMin: false },

          },



        },
        messages: {
          alerta: {
            required: "Este campo es requerido",

          },
          tipo: {
            required: "Este campo es requerido",

          },
          telefono: {
            required: "Este campo es requerido",
            prefijos: "Número inválido",
            prefijoMin: "Número inválido",

          },
          telefonoNuevo: {

            prefijos: "Número inválido",
            prefijoMin: "Número inválido",

          }


        },
        errorElement: "span",
        errorPlacement: function (error, element) {
          error.addClass("invalid-feedback");
          $(element).addClass("is-invalid");
          element.closest(".form-group").append(error);

        },

        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass("is-invalid");
        },
      });


  }
  formatoTelefono = (numero) => {
    let vNumero = null;
    let num1 = null;
    let num2 = null;
    let numFormat = null;

    vNumero = numero.split("-");
    num1 = vNumero[0].slice(1, 5);
    num2 = vNumero[0].slice(6, 9);
    numFormat = num1 + num2 + vNumero[1];
    return numFormat;
  }
  confirmarBtn = () => {
    let valores = this.state.alerta;
    let resultado = valores.split(" ");
    let telefono = null;
    let phoneNew = null;
    let crearNroTelefono = null;
    if (this.state.phoneFormat) {

      phoneNew = this.formatoTelefono(this.state.phoneFormat);
    }
    if (!this.state.telefonoActual && phoneNew) {
      crearNroTelefono = "S"
    }
    telefono = this.state.telefonoActual ? this.state.telefonoActual : phoneNew;

    trackPromise(
      SolicitudesService.confirmarAlertas(resultado[resultado.length - 1], telefono, crearNroTelefono, this.state.costo, this.state.suscripciones)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {

            mensajeExito("La Suscripción a Alertas se Realizó Correctamente");
            setTimeout(function () {
              history.push(ConfigService.getPathByName("suscripcionAlerta")?.url);
              window.location.reload();
            }, 3000);
          }
          else {
            Popup.create({
              title: "Suscripción a Alertas",
              content: jsonData.mensajeRetorno,
              buttons: {
                right: [{
                  text: 'Aceptar',
                  className: 'success',
                  action: function () {
                    Popup.close();

                  }
                }]
              }
            });
          }
        }

        ));

  }
  loadData() {
    var valores = this.state.alerta;

    var resultado = valores.split(" ");
    var label = this.state.alertaSelected.label;
    var res_label = label.split("-");
    var alerta = resultado[resultado.length - 1];
    var _itemsConfirm = [
      { concepto: "Número de Alerta", valor: resultado[resultado.length - 1] },
      { concepto: "Denominación", valor: res_label[0] },
      { concepto: "Moneda", valor: this.state.moneda },
      { concepto: "Costo", valor: this.state.costo },
      { concepto: "Teléfono Receptor", valor: this.state.phoneFormat ? this.state.phoneFormat : this.state.telefonoActual },
    ];

    var respuesta = [];
    if (alerta === "5") {

      for (var i = 0; i < this.state.lista.length; i++) {
        if (this.state.lista[i].suscribir === true) {
          var opcion = "N"
          if (this.state.lista[i].adicional === true)
            opcion = "S"
          respuesta.push({
            numeroTarjeta: this.state.lista[i].nroTarjeta,
            opcion: opcion,
          });
        }
      }
    }
    this.setState({ itemsConfirm: _itemsConfirm, suscripciones: respuesta });
    this.modalCtrlConfirm.click();
  }

  handleChangeSelector = (selectedOption) => {
    this.setState({ mostrarTarjeta: true })

    if (selectedOption == null) {
      this.setState({
        alerta: undefined,
        alertaSelected: undefined,
        costo: undefined,
        moneda: undefined
      });
    }
    else {
      this.setState({
        alerta: selectedOption.value,
        alertaSelected: selectedOption,
        costo: selectedOption.costo,
        moneda: selectedOption.moneda
      });
      /* if (selectedOption.value === "5") {
 
 
       }*/
    }

  };

  getAlertasDisponibles() {
    var alertas = [];

    trackPromise(
      SolicitudesService.getAlertasDisponibles()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.resultado.length; i++) {
              alertas.push({
                value: jsonData.resultado[i].numero,
                moneda: jsonData.resultado[i].moneda,
                costo: formatoSeparadorMilesValue(jsonData.resultado[i].costo),
                identificador: jsonData.resultado[i].identificador,
                label:
                  jsonData.resultado[i].descripcion + " -  COSTO " + formatoSeparadorMilesValue(jsonData.resultado[i].costo) + " ." + jsonData.resultado[i].moneda,
              });
            }
            this.setState({ listaAlertasTarjetas: this.obtenerListadoAlertasTarjetas() });
          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
            return;
          }
        }).catch(function (error) {
          // authService.logout()
          //console.log(error)
        }));


    return alertas;
  }

  rptAdicional = (valor, marca) => {

    var respuesta = [];

    for (var i = 0; i < this.state.lista.length; i++) {
      if (this.state.lista[i].nroTarjeta === valor) {
        respuesta.push({
          nroTarjeta: this.state.lista[i].nroTarjeta,
          suscribir: this.state.lista[i].suscribir,
          adicional: marca
        });
      }
      else {
        respuesta.push({
          nroTarjeta: this.state.lista[i].nroTarjeta,
          suscribir: this.state.lista[i].suscribir,
          adicional: this.state.lista[i].adicional

        });
      }
    }
    //console.log(respuesta)
    this.setState({ lista: respuesta }, this.enableNextAdicional(marca));

  };
  enableNextAdicional(marca) {
    this.checkGrillaAdi(marca);
  }

  rptSuscribir = (valor, marca) => {
    var respuesta = [];
    respuesta.push({
      nroTarjeta: valor,
      suscribir: marca,
      adicional: false

    });

    for (var i = 0; i < this.state.lista.length; i++) {
      if (this.state.lista[i].nroTarjeta !== valor) {
        respuesta.push({
          nroTarjeta: this.state.lista[i].nroTarjeta,
          suscribir: this.state.lista[i].suscribir,
          adicional: false
        });
      }
    }

    this.setState({ lista: respuesta, suscribiendo: valor }, this.enableNext(marca));

  };

  mostrarTarjetaFuncion = (valor) => {

    this.setState({ mostrarTarjeta: false });

  };

  obtenerListaTC = (vLista) => {


    // this.setState({ listaTC: valor });
    if (vLista.length > 0) {
      let vLitaNueva = [];
      if (this.state.listaAlertasTarjetas.length > 0) {
        for (var i = 0; i < vLista.length; i++) {
          if (this.state.listaAlertasTarjetas.filter(valor => valor.nroTarjeta !== vLista.nroTarjeta)) {
            vLitaNueva.push(vLista[i]);
          }

        }

      }

    }

  };
  enableNext(marca) {
    this.refTC.current.checkGrilla(marca);
  }


  enableNextAdicional(marca) {
    this.refTC.current.checkGrillaAdi(marca);
  }

  checkGrillaAdi(valor) {

    if (this.adiSele !== undefined) {
      //console.log("SELECCIONADO ADICIONAL "+this.adiSele.id)
      $("#" + this.adiSele.id).prop("checked", valor);
    }

  }

  checkGrilla(valor) {

    if (this.preSele !== undefined) {
      //console.log($("#" + this.preSele.id).prop("checked"));
      $("#" + this.preSele.id).prop("checked", valor);
    }

  }

  //obtener listado de alertas de tarjetas suscriptas
  obtenerListadoAlertasTarjetas = () => {

    trackPromise(
      SolicitudesService.obtenerListadoAlertasTarjetas().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);

        if (jsonData.codigoRetorno === "0") {

          for (var i = 0; i < jsonData.resultado.length; i++) {

            respuesta.push({
              nroTarjeta: jsonData.resultado[i].numeroCuenta,
              adicional: jsonData.resultado[i].adicional
            });
          }

        }
        this.setState({ listaAlertasTarjetas: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });

  };

  render() {
    return (
      <div className="content-wrapper">
        <ConfirmarOperacion
          idModal="idModalConfirm"
          title="Suscripción a Alertas"
          items={this.state.itemsConfirm}
          confirmarBtn={this.confirmarBtn.bind(this)}
        />
        <Titulo texto="Agregar Alerta" />
        <section className="content">
          <form id="idAlertaForm">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12 ">
                          {/* <label className="input-label-bold" style={{ color: "gray" }}>Paso 1 - Ingrese el nro. de teléfono celular que recibirá la alerta</label>*/}
                          {!this.state.showMe &&

                            <div className="col-md-4">

                              <label className="input-label-bold">Ingrese el nro. de teléfono celular que recibirá la alerta</label>
                              <CampoNroTelefono phoneSelectorValue={this.phoneSelectorValue.bind(this)} phoneSelector={this.state.phoneFormat} />
                            </div>}
                          {this.state.habAlert || this.state.showMe ?

                            <div className="col-md-9 form-group" >
                              <label className="input-label-bold">{this.state.paso} Seleccione la alerta a la que desea suscribirse</label>*
                              <div className="col-md-10 form-group" style={{ padding: 0 }} >
                                <label className="input-label">Lista de Alertas Disponibles *</label>
                                <div className="is-invalid" id="prueba">
                                  <Select id="tipo" name="tipo"
                                    defaultValue={this.state.alerta}
                                    onChange={this.handleChangeSelector}
                                    instanceId="groupselect"
                                    placeholder="-- seleccione --"
                                    options={this.state.alertasDisp}
                                    isClearable
                                    noOptionsMessage={() => 'SIN DATOS'}
                                    ref={c => (this.groupSelect) = c}
                                  />
                                </div>
                              </div>
                            </div> : <span />}
                          {this.state.alerta === "5" && !this.state.mostrarTarjeta ? <label className="input-label-bold" style={{ color: "gray" }}> No posee alertas para agregar, por favor verifique en la seccion de tarjetas de la pantalla principal </label> : <span />}
                          {this.state.alerta === "5" && this.state.mostrarTarjeta ? <div className="col-md-12">
                            <label className="input-label-bold">{this.state.paso} Seleccione tarjeta</label>*
                            <SeleccionTarjeta ref={this.refTC} parentCallback={this.funcionMostrarTarjeta} telefono={this.state.telefono} mostrarTarjeta={this.state.mostrarTarjeta} rptSuscribir={this.rptSuscribir.bind(this)} rptAdicional={this.rptAdicional.bind(this)} />
                          </div> : <span />}
                        </div>
                        
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-lg-8 col-md-4 col-12">
                        {this.state.alerta === "5" && this.state.mostrarTarjeta ? <label className="input-label-bold-obligatorio float-left">
                          (*) Campos Obligatorios
                        </label> : <span />}
                        </div>
                        <div className="col-lg-2 col-md-4 col-12 btn-consulta">
                          <button className="btn btn-cu-quintary float-right" onClick={this.volverListadoAlertas}><FontAwesomeIcon icon={faArrowLeft} /> Volver al Listado</button>


                        </div>
                        <div className="col-lg-2 col-md-4 col-12">
                          {this.state.mostrarTarjeta ? <button type="submit" className="btn btn-cu-primary" onClick={() => this.loadDataConfirmAccion()}><FontAwesomeIcon icon={faSave} />  Guardar</button> : <span />}
                          <a ref={(a) => (this.modalCtrlConfirm = a)}
                            href="#"
                            hidden
                            id="modalCtrlConfirm"
                            data-toggle="modal"
                            data-target="#idModalConfirm"
                          ></a>
                          <a ref={(a) => (this.modalCtrlConfirmSwitch = a)}
                            href="#"
                            hidden
                            id="modalCtrlConfirmSwitch"
                            data-toggle="modal"
                            data-target="#modalCtrlConfirmSwitch"
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </form>
        </section>
      </div>

    );
  }
}